import {useTranslation} from 'react-i18next';

import {Grid, Typography} from '@mui/material';

import {MatchActivityList} from '../MatchActivityList/MatchActivityList';
import {CommentForm} from '../NoteForm/CommentForm';

import {useApiRead} from '../../../../../../hooks/useApiRead';
import {GetRoutes} from '../../../../../../lib/api/GET/GetRoutes';
import {isMatchEvent, MatchActivity, MatchActivityResponse} from '../../../../../../types/MatchActivity';
import {UserMention} from '../../../../../../types/UserMention';

interface Props {
  companyId: string;
  matchId: string;
  userId: string;
  hideTitle?: boolean;
}

export const CompanyMatchNotes = ({companyId, matchId, userId, hideTitle = false}: Props) => {
  const {t: tr} = useTranslation('translation', {
    keyPrefix: 'companyApplicants.applicantsCard.cardDetails.companyMatchNotes',
  });
  const {data: activityResponse} = useApiRead<MatchActivityResponse>({
    path: GetRoutes.matchActivity(companyId, matchId),
    options: {queryKey: [`match-activity-${matchId}`], enabled: !!companyId && !!matchId},
  });

  const {data: userMentions, error} = useApiRead<UserMention[]>({
    path: GetRoutes.userMentions(companyId, matchId),
    options: {enabled: !!companyId && !!matchId},
  });

  const filterEmptyComments = (data?: MatchActivity[]) => {
    if (!data) {
      return [];
    }
    return data.filter((activity) => {
      if (isMatchEvent(activity)) {
        return true;
      }
      return !!activity.activityContent.content;
    });
  };

  return (
    <Grid width='100%'>
      {!hideTitle ? (
        <Grid container justifyContent='space-between'>
          <Typography variant='h3'>
            {`${tr('title')}: (${
              filterEmptyComments(activityResponse?.matchActivity).filter(
                (activity) => activity.activityType === 'match_comment'
              ).length
            })`}
          </Typography>
        </Grid>
      ) : null}

      <CommentForm companyId={companyId} matchId={matchId} userId={userId} userMentions={userMentions || []} />
      <MatchActivityList
        matchActivity={filterEmptyComments(activityResponse?.matchActivity)}
        matchId={matchId}
        companyId={companyId}
        userId={userId}
        userMentions={userMentions?.length && !error ? userMentions : []}
      />
    </Grid>
  );
};
